import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('petConcerns', ['getPetConcerns']),
  },

  methods: {
    findPetConcern(value) {
      return this.getPetConcerns.find((concern) => concern.value === value);
    },
    getCxConcernLabel(value) {
      return this.findPetConcern(value)?.friendly_name;
    },
    getConcernIcon(value) {
      return this.findPetConcern(value)?.icon;
    },
  },
};
